import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=5350129a&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=5350129a&prod&scoped=true&lang=css"
import style1 from "./Templates.vue?vue&type=style&index=1&id=5350129a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350129a",
  null
  
)

export default component.exports